import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setIsSubmit, setUserAddress, setConfirmTermsError, setIsReceivingAd,  reportDWH } from '../energySaleBlockSlice';
import AddressForm from  '../Partials/AddressForm/AddressForm';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import ThirdParty from '../../../Shared/ThirdParty/ThirdParty';
import { buildUrlAndOpenWindow } from '../../../../utilities/StringHelpers/StringHelpers';

const PersonalInfoPage = (props) => {
  const [address, setAddress] = useState(null);
  const [isConfirmTerms, setIsConfirmTerms] = useState(false);
  const [confirmTermsError, setConfirmTermsError] = useState('');

  useExtendedEffect((runSideEffects) => {
    gtag4({
      event: 'Energy_Step6_PersonalInfoPage',
      step: '6',
      action: 'PersonalInfoPage',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Personal Info Page', status: 'Ongoing', messageText: 'Personal Info Page - Display' })
    if (runSideEffects()) {
    }
  },
  [],);

  useEffect(() => {
    if(address){
      if(!isConfirmTerms){
        setConfirmTermsError('אנא אשר את תנאי השימוש');
        return;
      }
      handlePageContinueAfterValid();
    }

  }, [address]);

  //page params
  let title = 'כמה פרטים לסיום';
  let btnText = 'אפשר להמשיך';
  let currentPageFunction = handlePageContinue;
  const formid = 'saleJet';
  const isDisplayFooter = true;
  const isDisplayCheckboxReceivingAd = true;

  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='energy-sale-title margin-buttom-0'> {title} </h1>
      <h2 className='energy-sale-sub-title'></h2>
    </div>
  );

  let currentPageView = (
    <div>
      <AddressForm isSubmit={props.isSubmit} onSubmit={handlePageValidate} selectedAddress={props.selectedAddress} />
      <div className='checkbox-wrapper' style={{'marginTop': '24px'}}>
          <CheckBox
            id='terms-checkbox'
            onChange={() => handleOnConfirmTerms(!isConfirmTerms)}
            checked={isConfirmTerms}
            label={<> קראתי ואני מסכים <a href='#' onClick={() => buildUrlAndOpenWindow(props.programDetailsLink)}>לעיקרי פרטי התכנית</a>, <a href='#' onClick={() => buildUrlAndOpenWindow(props.connectionAgreementLink)}>להסכם ההתקשרות</a> <a href='#' onClick={() => buildUrlAndOpenWindow(props.generalTermsAgreementLink)}>ולתנאים הכלליים</a> </>}
          />
          {
            isDisplayCheckboxReceivingAd &&
            <CheckBox
              id='isReceivingAd-checkbox'
              checked={props.isReceivingAd}
              label= {<ThirdParty/>}
              onChange={() => handleOnReceivingAd(!props.isReceivingAd)}/>
          }
      </div>
    </div>
  );

  return (
    <>
      <div className='energy-sale-content-wrapper'>
        {currentPageHeadline}
        <div className='energy-sale-page-content width-340'>
          <form noValidate id='sale' onSubmit={handleSubmit}>
            {currentPageView}
          </form>
        </div>
      </div>
      <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} formid={formid} error={confirmTermsError} />
    </>
  );

  function handlePageContinue() {
    props.setIsSubmit(true);
  }


  async function handlePageValidate(data) {
    props.setIsSubmit(false);
    if (data.isValid) {
      if(data.selectedAddress){
        setAddress(data.selectedAddress);
      }
    }
  }

  function handlePageContinueAfterValid() {
    gtag4({
      event: 'Energy_Step6_PersonalInfoButton',
      step: '6',
      button: btnText,
      action: 'PersonalInfoButton',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.setUserAddress(address);
    props.reportDWH({ actionType: 'Personal Info Page', status: 'Ongoing', messageText: 'Personal Info Page - Clicked' })
    props.goToPage('digitalSignaturePage');
  }

  function handleOnConfirmTerms(value) {
    if(value){
      setConfirmTermsError('');
    }
    setIsConfirmTerms(value);
  }

  function handleOnReceivingAd(value){
    props.setIsReceivingAd(value);
  }


  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    offerName: state.energySaleBlock.offerName,
    isSubmit: state.energySaleBlock.isSubmit,
    selectedAddress: state.energySaleBlock.userAddress,
    generalTermsAgreementLink: state.energySaleBlock.energySaleBlockData.generalTermsAgreementLink,
    advertisingInfoLink: state.energySaleBlock.energySaleBlockData.advertisingInfoLink,
    isReceivingAd: state.energySaleBlock.personalInfo.isReceivingAd,
    confirmTerms: state.energySaleBlock.confirmTerms,
    isStartWithSelectedPackage: state.energySaleBlock.isStartWithSelectedPackage,
  };
};

const mapDispatchToProps = {
  goToPage,
  setIsSubmit,
  setUserAddress,
  setIsReceivingAd,
  setConfirmTermsError,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfoPage);
